export const CODE_BY_NAME = new Map<string, string>([
  ["english", "en"],
  ["assamese", "as"],
  ["bengali", "bn"],
  ["bodo", "brx"],
  ["dogri", "doi"],
  ["goan konkani", "gom"],
  ["gujarati", "gu"],
  ["hindi", "hi"],
  ["kannada", "kn"],
  ["kashmiri", "ks"],
  ["maithili", "mai"],
  ["malayalam", "ml"],
  ["manipuri", "mni-Mtei"],
  ["marathi", "mr"],
  ["nepali", "ne"],
  ["odia", "or"],
  ["punjabi", "pa"],
  ["sanskrit", "sa"],
  ["santali", "sat"],
  ["sindhi", "sd"],
  ["tamil", "ta"],
  ["telugu", "te"],
  ["urdu", "ur"],
]);

export const CODE_BY_LOWER = new Map<string, string>(
  [...CODE_BY_NAME.values()].map((c) => [c.toLowerCase(), c])
);
